import React, { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';
import { ethers } from 'ethers';
import { useNavigate } from 'react-router-dom';

import ASSETS from '../../assets';
import Stats from './Components/Stats';
import Blocks from './Components/Blocks';
import Transactions from './Components/Transactions';

const Home = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [search, setSearch] = useState('');

  const handleAddressClick = () => {
    if (!search.trim()) return;
    if (ethers.isAddress(search)) {
      navigate(`/accounts/${search}`);
    } else {
      navigate(`/transactions/${search}`);
    }
  };

  useEffect(() => {
    dispatch.transactions.handleGetAllTxs();
    const interval = setInterval(() => {
      dispatch.transactions.handleGetAllTxs();
    }, 10000);
    return () => clearInterval(interval);
    // eslint-disable-next-line
  }, []);
  return (
    <div className='flex-grow'>
      <div
        className='h-[273px] bg-cover bg-center bg-no-repeat px-[28px] pt-[55px]'
        style={{ backgroundImage: `url(${ASSETS.waves})` }}
      >
        <p className='text-xl text-bryt-primary-main font-semibold'>
          The RYT Blockchain Explorer
        </p>
        <div className='w-full max-w-[783px] h-12 my-3 border border-bryt-grey-200 rounded-lg bg-white flex items-center pl-4 pr-[7px] py-[7px] gap-4'>
          <div className='flex items-center gap-[33px]'>
            <p className='text-[15px]'>All Filters</p>
            <img src={ASSETS.arrowDown} alt='' />
          </div>
          <input
            type='search'
            name=''
            className='flex-grow h-full outline-none border-none bg-transparent text-bryt-primary-main text-[15px] placeholder:text-bryt-grey-500'
            placeholder='Search by Address / Txn Hash / Block'
            id=''
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
          <div
            className='h-full aspect-square bg-bryt-primary-main rounded-lg grid place-items-center cursor-pointer'
            onClick={handleAddressClick}
          >
            <img src={ASSETS.search} alt='' />
          </div>
        </div>
        <p className='text-sm text-bryt-primary-main'>
          Use <span className='font-bold'>RYT SDK</span> for network
          communications
        </p>
      </div>
      <Stats />
      <div className='grid grid-cols-2 px-10 gap-4 my-5'>
        <Blocks />
        <Transactions />
      </div>
    </div>
  );
};

export default Home;
